import ResourceSelect from "../../../../../../../../components/shared/inputs/ResourceSelect";
import { useFilterResourceParams } from "../../../../../hooks/filters/useFilterResourceParams";
import { getSettingsResourceSearchFilters, renderSettingsResourceLabel } from "../../../../../../../../utils/helpers/settings";

export const getHourTypeColor = (hourType: string) => {
    switch (hourType) {
        case "unit":
            return "#1e3a5f";
        case "regular":
            return "#3B82F6";
        case "override":
            return "#EC4899";
        case "amount":
            return "#8B5CF6";
        case "overtime":
            return "#F59E0B";
        case "double-time":
            return "#F97316";
        case "double-time-and-half":
            return "#EF4444";
        case "pto":
            return "#10B981";
        case "unpaid":
            return "#94A3B8";
        case "holiday":
            return "#16A34A";
        default:
            return "#000";
    }
};

type PayCodeSelectProps = {
    value?: any;
    onChange?: (value: any) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    forBreak?: boolean;
    filterName?: string;
};

const renderPayCodeLabel = (item: any) => (
    <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-min-w-0">
        <span
            className="tw-inline-block tw-w-2.5 tw-h-2.5 tw-border tw-rounded-full tw-shrink-0"
            style={{
                backgroundColor: getHourTypeColor(item?.hourType),
                borderColor: getHourTypeColor(item?.hourType),
            }}
        />
        <span className="tw-truncate">{renderSettingsResourceLabel(item)}</span>
    </span>
);

const getPayCodeSearchFilter = (search: string) =>
    getSettingsResourceSearchFilters(search, ["id", "code", "description", "hourType"]);

function PayCodeSelect({ value, onChange, placeholder, disabled, className, forBreak, filterName }: PayCodeSelectProps) {
    const hourType = value?.hourType;
    const filterParams = useFilterResourceParams(filterName);
    return (
        <ResourceSelect
            mode="single"
            value={value}
            onChange={onChange}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            resourcePath="/pay-code"
            params={{
                forSchedule: true,
                withoutLookups: true,
                ...(forBreak ? { forBreak: true } : {}),
                ...(filterParams || {})
            }}
            style={value ? {
                borderColor: getHourTypeColor(hourType),
                color: getHourTypeColor(hourType),
                fontWeight: 600
            } : undefined}
            renderLabel={renderPayCodeLabel}
            getSearchFilter={getPayCodeSearchFilter}
        />
    );
}

export default PayCodeSelect;
